export default "__VITE_ASSET__DE1MI3Vd__"